export default __webpack_public_path__ + "static/media/home_video.edb478b1.webp";